import cnt from "../../services/definedConstant";
import { BOM } from "../../services/definedMethod";

export const rightAction = (btnType) => {
  // console.log(btnType);
  return (dispatch) => {
    dispatch({
      type: btnType,
    });
  };
};

export const getCurrentTemplate = (
  body,
  url,
  setIsLoading,
  setCurrentTemplateData
) => {
  setIsLoading(true);
  return async (dispatch) => {
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        console.log(err);
      } else {
        console.log(res);
        const objList = res;
        setCurrentTemplateData(objList);
        dispatch({
          type: cnt.CURRENT_TEMPLATE,
          payload: { name: "charges", data: res },
        });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };
};

// export const onSelectItemAction = (selectedRowKeys, objParam) =>{
//   return (dispatch)=>{
//       console.log(selectedRowKeys);
//       console.log(objParam);

//        //HOLD THE OBJECT SELECTED HERE
//     // setSelectedRow(objParam[0]);
//     dispatch({
//       type: cnt.RIGHT_DETAIL_BTN,
//     });
//   }
// }
